import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';
import { withCreatePermission, withSignOffViewPermission } from 'global-services/OhsPermission';
import { ModuleConfig } from 'global-services/constants/OhsObject';

const commonPermission = (user: OhsUser) => user?.configs?.corporateRisk?.PERMISSIONS.view || false;

const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.CorporateRisk}/${path}`,
  permission,
});

const returnDefaultRoute = (user: OhsUser) => {
  const withView = commonPermission(user);
  if (withView) return createRoute('home', commonPermission);
  return createRoute('add', (u) => withCreatePermission(u, ModuleConfig.CorporateRisk));
};

const OhsCorporateRiskRouteList = {
  [ModuleRoute.Default]: (user: OhsUser) => returnDefaultRoute(user),

  [ModuleRoute.Home]: createRoute('home', commonPermission),
  [ModuleRoute.Add]: createRoute('add', (user) =>
    withCreatePermission(user, ModuleConfig.CorporateRisk)
  ),
  [ModuleRoute.Details]: createRoute(':criskId/view', commonPermission),
  [ModuleRoute.Edit]: createRoute(':criskId/edit', commonPermission),
  [ModuleRoute.SignOff]: createRoute(':criskId/task/:taskId/signoff', (user) =>
    withSignOffViewPermission(user, ModuleConfig.CorporateRisk)
  ),
  [ModuleRoute.Evidence]: createRoute(':criskId/task/:taskId/completed', commonPermission),
};

export default OhsCorporateRiskRouteList;
